import React from "react";
import { MDBSpinner } from "mdbreact";
import { bool } from "prop-types";
import styles from "./style.module.scss";

const LoadingPage = props => {
  if (props.error) {
    throw new Error(`Couldn't load LoadingPage`);
  } else if (props.pastDelay) {
    return (
      <div className={styles.customLoader}>
        <div>
          <MDBSpinner big />
        </div>
      </div>
    );
  } else return null;
};

LoadingPage.propTypes = {
  error: bool
};

export default LoadingPage;
